var _path, _ellipse, _circle, _circle2, _circle3, _ellipse2, _circle4, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLogoHealthCase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 43,
    viewBox: "0 0 213 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 4.023L35.367 36.405M66.969 36.405L52.433 4.023M66.969 36.405L35.366 14.86M18.17 4.023l17.196 32.382M4.088 36.405L35.366 14.86M18.17 4.023L4.088 36.405",
    stroke: "#2B2A9E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.397,
    cy: 4.023,
    rx: 4.056,
    ry: 4.023,
    fill: "#AD3EBF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.023,
    transform: "matrix(-1 0 0 1 52.498 4.023)",
    fill: "#AD3EBF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.366,
    cy: 36.34,
    r: 4.023,
    fill: "#AD3EBF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.366,
    cy: 14.925,
    r: 4.023,
    fill: "#AD3EBF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.056,
    cy: 36.34,
    rx: 4.056,
    ry: 4.023,
    fill: "#AD3EBF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4.023,
    transform: "matrix(-1 0 0 1 66.84 36.34)",
    fill: "#AD3EBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.883 32.252c-.745 0-1.118-.393-1.118-1.177V12.269c0-.785.373-1.178 1.118-1.178.314 0 .56.07.736.206.196.118.373.324.53.618l7.622 14.363 7.593-14.362c.157-.295.324-.5.501-.619.176-.137.431-.206.765-.206.726 0 1.089.393 1.089 1.178v18.806c0 .785-.373 1.177-1.119 1.177-.745 0-1.118-.393-1.118-1.177V15.83l-6.651 12.508c-.138.255-.285.441-.442.559-.137.098-.343.147-.618.147-.275 0-.49-.059-.647-.177a1.464 1.464 0 01-.412-.53l-6.74-12.478v15.216c0 .785-.363 1.177-1.089 1.177zm27.09 0c-.471 0-.795-.157-.971-.471-.177-.314-.157-.706.059-1.177l8.093-18.424c.314-.726.795-1.089 1.442-1.089.294 0 .559.089.795.265.255.157.461.432.618.824l8.123 18.424c.215.47.245.863.088 1.177-.157.314-.471.47-.942.47-.353 0-.638-.087-.853-.264-.216-.196-.393-.47-.53-.824l-1.913-4.415h-10.801l-1.884 4.415c-.314.726-.755 1.089-1.324 1.089zm8.594-18.13l-4.503 10.596h9.064l-4.502-10.595h-.059zm22.803 18.13c-.686 0-1.177-.353-1.471-1.06l-8.094-18.511c-.215-.49-.206-.873.03-1.148.235-.294.559-.442.971-.442.353 0 .618.089.795.265.196.157.363.393.5.707l7.299 16.922 7.269-16.952c.137-.314.304-.55.5-.706.197-.157.471-.236.824-.236.412 0 .716.157.913.471.196.295.196.667 0 1.119l-8.094 18.511c-.157.354-.343.619-.559.795-.216.177-.51.265-.883.265zm17.436 0c-.804 0-1.206-.422-1.206-1.266v-18.63c0-.843.402-1.265 1.206-1.265.805 0 1.207.422 1.207 1.266v18.63c0 .843-.402 1.265-1.207 1.265zm11.032 0c-.765 0-1.148-.402-1.148-1.207V12.327c0-.824.353-1.236 1.06-1.236.294 0 .52.06.677.177.157.098.333.284.529.56l12.126 16.157V12.268c0-.785.382-1.178 1.147-1.178.726 0 1.089.393 1.089 1.178v18.806c0 .785-.323 1.177-.971 1.177-.294 0-.53-.059-.706-.177-.177-.117-.363-.304-.559-.559L171.956 15.3v15.745c0 .805-.372 1.207-1.118 1.207z",
    fill: "#2B2A9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.742 32.252c-.49 0-.843-.177-1.059-.53-.196-.373-.137-.755.176-1.148l6.769-9.123-6.356-8.623c-.334-.432-.403-.824-.206-1.177.215-.373.549-.56 1-.56.491 0 .932.265 1.325.795l5.65 7.74 5.621-7.74c.373-.53.805-.795 1.295-.795.471 0 .805.187 1.001.56.216.353.157.745-.177 1.177l-6.386 8.623 6.798 9.123c.295.393.344.775.148 1.148-.197.353-.54.53-1.031.53-.49 0-.931-.265-1.324-.795l-5.974-8.181-5.975 8.181c-.372.53-.804.795-1.295.795z",
    fill: "#AD3EBF"
  })));
}
export default SvgLogoHealthCase;